import { render, staticRenderFns } from "./PulloutQuestionNumber.vue?vue&type=template&id=27d0f654&scoped=true&"
import script from "./PulloutQuestionNumber.vue?vue&type=script&lang=js&"
export * from "./PulloutQuestionNumber.vue?vue&type=script&lang=js&"
import style0 from "./PulloutQuestionNumber.vue?vue&type=style&index=0&id=27d0f654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0f654",
  null
  
)

export default component.exports